var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var _a;
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext } from 'react';
import useAuthentication from '../hooks/useAuthentication';
export var Features;
(function (Features) {
  Features["PROFILE"] = "profile";
})(Features || (Features = {}));
export var FeatureToggleContext = /*#__PURE__*/createContext({
  featureToggles: (_a = {}, _a[Features.PROFILE] = false, _a)
});
var FeatureToggleProvider = function (_a) {
  var _b;
  var children = _a.children;
  var user = useAuthentication().user;
  // Define if feature is enabled
  var featureToggles = (_b = {}, _b[Features.PROFILE] = !(user === null || user === void 0 ? void 0 : user.internalAdmin), _b);
  return _jsx(FeatureToggleContext.Provider, __assign({
    value: {
      featureToggles: featureToggles
    }
  }, {
    children: children
  }));
};
export default FeatureToggleProvider;